module.exports = __webpack_public_path__ + "img/xybb.a3b608a9.png";